import { Typography } from "@mui/material";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import * as React from "react";

interface LSResultItemSeriesProps {
  series: string;
}

export const LSResultItemSeries: React.FC<LSResultItemSeriesProps> = ({
  series,
}) => {
  const { translate } = useLanguage();

  if (!series) {
    return null;
  }

  return (
    <Typography variant="subtitle2">
      {translate("series")}: {series}
    </Typography>
  );
};
